import { RankingSelector } from 'feature/ranking/top-tab';
import { CLICK, component, demoFile, story } from 'system/demo';
import { t } from "util/stdtypes";

demoFile('feature/ranking/top-tab');

component('RankingSelector', RankingSelector, {
    config: {commentRankers: [
        {label: t('Best'), ranker: () => []},
        {label: t('Newest'), ranker: () => []}
    ]}
});
